// Q-Test V2 ekran metinleri. YONERGE, backend/core/data/qtest_v2_icerik.json → "yonerge" ile aynıdır.
export const YONERGE =
  "Aşağıdaki ifadeleri olmak istediğiniz kişiye göre değil, günlük yaşamda çoğunlukla nasıl davrandığınızı düşünerek değerlendirin. Yalnızca sizi belirgin biçimde tanımlayan ifadeleri işaretleyin.";

export const WING_YONERGE =
  "Aşağıdaki iki ifadeden sizi daha fazla tanımlayanı seçin.";

export const QUESTIONS_PER_PAGE = 10;
